export default __webpack_public_path__ + "static/media/glasshouse_harvest_c.d96425a1.mp4";